import { View } from 'react-native';

import ListItemLoader from '../../Components/ListItemLoader';
import { numberToArray } from '../../Helper';
import themeStyle from '../../Theme/styles';

import EventItemLoader from './components/EventItemLoader';

const ReservationsLoader = () => {
  return (
    <View>
      {/* Tabs */}
      <View style={themeStyle.flexDirectionRow}>
        {numberToArray(2).map((rt, i) => (
          <View key={i} style={[themeStyle.spacingRight, { width: '30%' }]}>
            <ListItemLoader leftSize={25} textSize={32.5} withLeftIcon />
          </View>
        ))}
      </View>
      {/* Event List for this store */}
      <View style={themeStyle.pageVerticalSpacing}>
        <EventItemLoader />
      </View>
    </View>
  );
};

export default ReservationsLoader;
